import { useQuery } from '@tanstack/react-query';
import { httpClient, ROOT_URL } from '../../App';

export const useMetadataCurrency = () => {
  const { data, refetch } = useQuery(
    ['/api/v1/currencies'],
    async () => {
      const response = await httpClient.get(`${ROOT_URL}/api/v1/currencies`);
      return response.data;
    }
  );
  
  const metadataCurrency = (data && data?.length > 0 && Array.isArray(data) ? data : data?.data || []).map((item: any) => ({
    value: item.code || item.currencyCode,
    label: item.code || item.currencyCode,
  }));

  return { metadataCurrency, refetch };
};

